$(document).on('turbolinks:load', function() {
  let activeDate = $(".btn.active").data('date');
  filterByDate(activeDate);

  $(".js-date-filter").click(function() {
    onDateFilterClick($(this));
    hideNotNeededTime();
  });

  $(".js-schedule-filters input[type=checkbox]").click(function() {
    if($(this).attr('id') == "js-schedule-filter-all" && $(this).prop("checked")){
      $(".js-schedule-item").show();
      $('.js-schedule-filters').find('input:checked').not('#js-schedule-filter-all').each(function() {
        $(this).prop("checked", false);
    });
    }
    else{
      if($(".js-schedule-filters li.js-schedule-filter :checkbox:checked").length > 0) {
        $(".js-schedule-item").hide();
        $("#js-schedule-filter-all" ).prop("checked", false);
        
        $('.js-schedule-filters').find('input:checked').each(function() {
            $(".js-track-" + $(this).val()).show();
        });
  
      } else {
        $("#js-schedule-filter-all" ).prop("checked", true);
        $(".js-schedule-item").show();
      }
    }
    hideNotNeededTime();
  });

  function filterByDate(date){
    $('.js-schedule-time-slot').each(function() {
      if($(this).data("date") != date){
        $(this).hide();
      } else{
        $(this).show();
      }
    });
  };

  function onDateFilterClick($filterElement){
    let activeDate = $filterElement.data("date");
    filterByDate(activeDate);
    $(".js-date-filter").removeClass('active'); 
    $filterElement.addClass('active');   
  }

  function hideNotNeededTime(){
    $('.js-schedule-time').each(function() {
      let visibleEventsCount = $(this).nextAll().filter(function(){
        return $(this).children().filter(":visible").length > 0
      }).length;

      if(visibleEventsCount == 0){
        $(this).hide();
      }else{
        $(this).show();
      }
    })
  }
});

